import React, { useEffect, useState } from "react";
import "./CalendarView.css";
import { useStateValue } from "../utils/Provider/StateProvider";
import ReactWhatsapp from "react-whatsapp";

import { FaChevronCircleLeft, FaChevronCircleRight } from "react-icons/fa";
import SendWpMsgOnNumModal from "./ModalComponent/SendWpMsgOnNumModal";
import LoadingScreen from "./LoadingPage/LoadingScreen";

function CalendarView() {
  const [{ myrelative, myfamily }, dispatch] = useStateValue();

  // Modals:
  const [closeSendWPMsgModal, setCloseSendWPMsgModal] = useState(false);
  const [loading, setLoading] = useState(false);
  // constants:
  let currentDate = new Date();
  const daysOfWeek = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  const weekdayFactor = {
    Sunday: 0,
    Monday: 1,
    Tuesday: 2,
    Wednesday: 3,
    Thursday: 4,
    Friday: 5,
    Saturday: 6,
  };

  const monthFactor = {
    January: 1,
    February: 2,
    March: 3,
    April: 4,
    May: 5,
    June: 6,
    July: 7,
    August: 8,
    September: 9,
    Octomber: 10,
    November: 11,
    December: 12,
  };

  // States:
  const [monthYear, setMonthYear] = useState("");
  const [calendarDate, setCalendarDate] = useState(null);
  const [highLightCurDate, setHighLightCurDate] = useState("");
  const [eventsHighLight, setEventsHighLights] = useState();
  const [currentViewMonth, setCurrentViewMonth] = useState(
    currentDate.getMonth() + 1
  );
  const [ViewEventofThisDate, setViewEventofThisDate] = useState(
    currentDate.getDate()
  );

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      renderCalendar();
    }, 1000);
  }, [myrelative, myfamily]);

  const peopleEvents = (month) => {
    const eventsMap = {};

    myrelative &&
      myrelative.forEach((i) => {
        i.person_data.forEach((person) => {
          // Birthday Events:
          if (person.DOB) {
            const DOBDate = new Date(
              person.DOB.split("-")[0],
              person.DOB.split("-")[1] - 1,
              person.DOB.split("-")[2]
            );

            const monthOfDOB = DOBDate.toLocaleDateString("default", {
              month: "long",
            });

            if (monthOfDOB === month.split(" ")[0]) {
              const mapKey = parseInt(person.DOB.split("-")[2]);
              if (!eventsMap.hasOwnProperty(mapKey)) {
                eventsMap[`${mapKey}`] = [];
              }
              eventsMap[`${mapKey}`].push({
                name: person.name,
                DOB: person.DOB,
                contact: person.contact_detail,
                event: `${person.name} has his Birthday🎉 on ${person.DOB} 🥳`,
                type: "birthday",
                message: `*Happiest Birthday, ${person.name}!* \nWishing you a day filled with joy and laughter. May this year bring you endless blessings and prosperty. Enjoy your special day to the fullest! `,
                date: DOBDate.toLocaleDateString("default", {
                  day: "numeric",
                  month: "long",
                }),
              });
            }
            setEventsHighLights(eventsMap);
          }

          //   Aniversary events:
          if (person.aniversary) {
            const AnvDate = new Date(
              person.aniversary.split("-")[0],
              person.aniversary.split("-")[1] - 1,
              person.aniversary.split("-")[2]
            );

            const monthOfAnv = AnvDate.toLocaleDateString("default", {
              month: "long",
            });

            if (monthOfAnv === month.split(" ")[0]) {
              const mapKey = parseInt(person.aniversary.split("-")[2]);
              if (!eventsMap.hasOwnProperty(mapKey)) {
                eventsMap[`${mapKey}`] = [];
              }
              eventsMap[`${mapKey}`].push({
                name: person.name,
                aniversary: person.aniversary,
                event: `${person.name} has his Aniversary on ${person.aniversary} 🥳`,
                type: "aniversary",
                contact: person.contact_detail,
                message: `*Happy Anniversary to both of you!* \nMay your bond continue to grow stronger with each passing day. Wishing you both a lifetime of happiness and cherished moments together. Cheers to your love story...!`,
                date: AnvDate.toLocaleDateString("default", {
                  day: "numeric",
                  month: "long",
                }),
              });
            }
            setEventsHighLights(eventsMap);
          }
        });
      });

    setLoading(false);
  };

  function renderCalendar() {
    // calendarGrid.innerHTML = ""; // Clear existing cells
    const firstDay = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      1
    );
    const lastDay = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() + 1,
      0
    );
    const daysInMonth = lastDay.getDate();

    // Set month and year title
    const displayMonth = firstDay.toLocaleDateString("default", {
      month: "long",
      year: "numeric",
    });

    setMonthYear(displayMonth);

    // Add day cells
    const tempDate = [];
    // Add Zeros at the beginning:
    const startMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      1
    );

    const currentDayOfWeek = daysOfWeek[startMonth.getDay()];
    const addZero = weekdayFactor[currentDayOfWeek];
    for (let i = 0; i < addZero; i++) {
      tempDate.push(0);
    }
    for (let day = 1; day <= daysInMonth; day++) {
      tempDate.push(day);
    }

    let allWeeks = [];
    let tempWeek = [];
    tempDate.forEach((i, index) => {
      tempWeek.push(i);
      if ((index + 1) % 7 === 0) {
        allWeeks.push(tempWeek);
        tempWeek = [];
      }
    });

    // Check if there is a partial week left to add after the loop
    if (tempWeek.length > 0) {
      console.log(tempWeek.length, 7 - tempWeek.length);
      while (tempWeek.length < 7) {
        tempWeek.push(0);
        if (tempWeek.length === 7) {
          break;
        }
      }
      allWeeks.push(tempWeek);
    }

    setHighLightCurDate(currentDate.getDate());
    setCalendarDate(allWeeks);
    peopleEvents(displayMonth);
  }

  function moveMonth(delta) {
    const tempFactor = currentViewMonth + delta;
    setCurrentViewMonth(tempFactor);
    currentDate.setMonth(tempFactor);
    renderCalendar();
  }

  return (
    <div className="calendar_main">
      {loading && <LoadingScreen showText={true} />}
      {!loading && (
        <div class="calendar">
          <div class="calendar-nav">
            <button onClick={() => moveMonth(-1)}>
              <div>
                <FaChevronCircleLeft />
              </div>
            </button>
            <h2 id="monthYear">{monthYear ? monthYear : "loading..."}</h2>
            <button onClick={() => moveMonth(1)}>
              <div>
                <FaChevronCircleRight />
              </div>
            </button>
          </div>

          <div class="calendar-grid">
            <div className="calendar_weekHeader_div">
              <div>Sun</div>
              <div>Mon</div>
              <div>Tue</div>
              <div>Wed</div>
              <div>Thu</div>
              <div>Fri</div>
              <div>Sat</div>
            </div>

            <div>
              {calendarDate &&
                eventsHighLight &&
                calendarDate.map((weeks, index) => (
                  <div className="calendar_date_display">
                    {weeks.map((date) => (
                      <div
                        className="calendar_only_date"
                        onClick={() =>
                          setViewEventofThisDate(
                            date.length === 1 ? "0" + date : date
                          )
                        }
                      >
                        {date === 0 ? (
                          " "
                        ) : date === highLightCurDate ? (
                          <p
                            className={`${
                              monthYear ===
                                currentDate.toLocaleDateString("default", {
                                  month: "long",
                                  year: "numeric",
                                }) && `calendar_current_date`
                            } ${
                              eventsHighLight &&
                              eventsHighLight.hasOwnProperty(date) &&
                              "calendar_flexView"
                            }`}
                          >
                            {date} &nbsp;
                            {eventsHighLight &&
                              eventsHighLight.hasOwnProperty(date) && (
                                <div className="calendar_greenDot"></div>
                              )}
                          </p>
                        ) : (
                          <p
                            className={`${
                              eventsHighLight &&
                              eventsHighLight.hasOwnProperty(date) &&
                              "calendar_flexView"
                            }
                            ${
                              date === ViewEventofThisDate &&
                              "selected_calendar_date"
                            }
                          `}
                          >
                            {date} &nbsp;
                            {eventsHighLight &&
                              eventsHighLight.hasOwnProperty(date) && (
                                <div className="calendar_greenDot"></div>
                              )}
                          </p>
                        )}
                      </div>
                    ))}
                  </div>
                ))}
            </div>
          </div>

          <div className="calendar_view_events_details">
            <p className="calendar_view_total_event">
              There are{" "}
              <b>
                {eventsHighLight && Object.keys(eventsHighLight).length} Events
              </b>{" "}
              this Month
            </p>

            <div className="calendar_events_view_container">
              {eventsHighLight &&
              ViewEventofThisDate &&
              eventsHighLight.hasOwnProperty(ViewEventofThisDate) ? (
                eventsHighLight[ViewEventofThisDate].map((data) => (
                  <div className="calendar_event_cards_maindiv">
                    <div className="calendar_event_cards">
                      <div className="calendar_event_tag">{data.type}</div>
                      <p>{data.event}</p>
                    </div>

                    <div>
                      <p>
                        {data.date ===
                          currentDate.toLocaleDateString("default", {
                            day: "numeric",
                            month: "long",
                          }) && data.contact ? (
                          <ReactWhatsapp
                            number={data.contact}
                            message={data.message}
                            className="whatsapp_message_custom_btn"
                          >
                            send message
                          </ReactWhatsapp>
                        ) : (
                          data.date ===
                            currentDate.toLocaleDateString("default", {
                              day: "numeric",
                              month: "long",
                            }) && (
                            <div>
                              <p
                                className="whatsapp_message_custom_btn"
                                onClick={() => setCloseSendWPMsgModal(true)}
                                style={{ textAlign: "center" }}
                              >
                                send message
                              </p>
                              {closeSendWPMsgModal && (
                                <SendWpMsgOnNumModal
                                  title="provide contact details"
                                  onCloseHandler={() =>
                                    setCloseSendWPMsgModal(false)
                                  }
                                  message={data.message}
                                />
                              )}
                            </div>
                          )
                        )}

                        {data.date !==
                          currentDate.toLocaleDateString("default", {
                            day: "numeric",
                            month: "long",
                          }) && (
                          <p
                            className="whatsapp_message_custom_btn"
                            style={{ cursor: "not-allowed" }}
                          >
                            Wish later
                          </p>
                        )}
                      </p>
                    </div>
                  </div>
                ))
              ) : (
                <div className="calendar_event_cards">
                  <p>No Event on this date !</p>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default CalendarView;
